import directives from './module';
import getCommonLinks from '../routes/commonLinks';
import {Utils} from '../underscore-extensions';

class CommonLink implements ng.IComponentController {
    name: string;
    className: string;
    url: string;
    product: AnimatronProduct;
    private href: string;

    constructor(private $state: ng.ui.IStateService) {
    }

    $onChanges() {
        this.product = this.product || Utils.getProductByState(this.$state);
        this.href     = this.url ? this.getByUrl() : this.getByName();

    }

    private getByName() {
        const links = getCommonLinks(this.product);
        return links[this.name];
    }

    private getByUrl() {
        return `/${this.product.toLowerCase()}${this.url}`;
    }
}

directives.component('commonLink', {
    bindings: {
        name: '@?',
        url: '@?',
        product: '@?',
        className: '@?'
    },
    transclude: true,
    controller: CommonLink,
    template: '<a ng-if="$ctrl.href" class="{{$ctrl.className}}" ng-href="{{$ctrl.href}}" ng-transclude></a> <ng-transclude ng-if="!$ctrl.href"></ng-transclude>'
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/commonLink.ts